import { cn } from "./cn";

const sizes = {
  sm: "size-8 text-sm rounded-[9px]",
  md: "size-10 text-base rounded-[11px]",
  lg: "size-12 text-lg rounded-[13px]",
};

export function AppIcon({
  initial,
  tone = "brand",
  size = "md",
  className,
}: {
  initial: string;
  tone?: "brand" | "teal";
  size?: keyof typeof sizes;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "grid shrink-0 place-items-center font-display font-bold text-white shadow-card",
        tone === "brand" ? "bg-brand-gradient" : "bg-teal-gradient",
        sizes[size],
        className,
      )}
    >
      {initial}
    </span>
  );
}
